import styled from 'styled-components';

export const UploadSection = styled.div`
  width: 100%;
  margin: 12px 0 24px;
`;

export const UploadDescription = styled.p`
  margin: 0 0 10px;
  color: ${(p) => p.theme.colors.gray500};
  font-size: ${(p) => p.theme.fontSizes.sm};
`;

export const UploadRow = styled.div`
  display: flex;
  min-height: 54px;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 8px 0;
  border-bottom: ${(p) => p.theme.borders.base};
  border-color: ${(p) => p.theme.colors.gray200};

  @media screen and (max-width: 640px) {
    align-items: stretch;
    flex-direction: column;
  }
`;

export const FileName = styled.span`
  min-width: 0;
  overflow: hidden;
  color: ${(p) => p.theme.colors.gray500};
  font-size: ${(p) => p.theme.fontSizes.sm};
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const RemoveButton = styled.button`
  flex: 0 0 auto;
  padding: 8px;
  border: 0;
  background: transparent;
  color: ${(p) => p.theme.colors.primary500};
  cursor: pointer;
`;

export const HiddenFileInput = styled.input`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
  white-space: nowrap;
`;

export const CandidateReview = styled.div`
  margin-top: 20px;
  padding: 20px;
  border: 1px solid ${(p) => p.theme.colors.gray200};
  border-radius: ${(p) => p.theme.radii.base};
  background: ${(p) => p.theme.colors.gray000};
`;

export const CandidateField = styled.fieldset`
  margin: 0 0 18px;
  padding: 0 0 14px;
  border: 0;
  border-bottom: 1px solid ${(p) => p.theme.colors.gray200};

  legend {
    margin-bottom: 8px;
    color: ${(p) => p.theme.colors.gray500};
    font-size: ${(p) => p.theme.fontSizes.sm};
    font-weight: 600;
  }
`;

export const SourceText = styled.span`
  display: block;
  color: ${(p) => p.theme.colors.gray400};
  font-size: ${(p) => p.theme.fontSizes.xs};
`;

export const ReviewActions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 18px;
`;
